import './ImageGaller.scss';

class ImageGaller {

  constructor(node) {
    this.node = node;
  }

  init() {
    //console.log();
  }

}

JSModules['ImageGaller'] = ImageGaller;
export default ImageGaller;
